import { type PropsWithChildren } from "react";
import { MsalInitializer } from "../../MsalInitializer.tsx";
import { GoogleProvider } from "../google/GoogleProvider.tsx";
import { SessionProvider } from "../SessionProvider.tsx";

/**
 * Providers for authenticated users only
 */
export function AuthenticatedProviders({ children }: PropsWithChildren) {
    return (
        <MsalInitializer>
            <SessionProvider>
                <GoogleProvider>{children}</GoogleProvider>
            </SessionProvider>
        </MsalInitializer>
    );
}
